import { Asset } from 'contentful'
import { Button } from '~/components/general/Button'
import { trackEvent } from '~/utils/tracking'

type BannerProps = {
  fields: {
    titleText?: string
    bodyText?: string
    ctaButtonText?: string
    ctaButtonLink?: string
    backgroundColour?: string
    image?: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }
}

export const Banner = ({ fields }: BannerProps) => {
  if (!fields.titleText) {
    return <></>
  }

  return (
    <div
      className="flex flex-row justify-around rounded-[40px] mt-[96px] max-sm:flex-col"
      style={{ background: fields.backgroundColour }}
    >
      <div className="max-w-[446px] flex flex-col justify-center max-md:items-center lg:p-[64px] max-md:text-center p-[32px] max-sm:w-[100%]">
        <h2 className="text-xl">{fields.titleText}</h2>
        <p className="text-s mt-[24px] mb-[24px]">{fields.bodyText}</p>
        <Button
          text={fields.ctaButtonText}
          type={'link'}
          className="!h-[52px]"
          href={fields.ctaButtonLink}
          onClick={() => {
            trackEvent('homepage_click_cta', {
              website_host: 'career.io',
              block: 'promo_banner',
              // @ts-expect-error not yet added on typescript. check the release notes to see which version was added. at the moment is experimental
              device: `${window.navigator.userAgentData.platform} - ${
                // @ts-expect-error not yet added on typescript. check the release notes to see which version was added. at the moment is experimental
                window.navigator.userAgentData.mobile ? 'mobile' : 'desktop'
              }`,
              cta: 'Find Out How',
              target: fields.ctaButtonLink as string,
            })
          }}
        />
      </div>
      <div className="flex justify-center items-center">
        <img
          className="object-contain w-[576px]"
          src={fields?.image?.fields?.file?.url}
          alt={fields?.image?.fields?.title}
        />
      </div>
    </div>
  )
}
